"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Text = _interopRequireDefault(require("../Text"));
var _style = require("../Input/style");
var _Icon = require("../Icon");
var _style2 = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
class TextArea extends _react.default.Component {
  render() {
    const _a = this.props,
      {
        value,
        label,
        hasError,
        help,
        disabled,
        rows,
        onChange,
        id,
        fullHeight,
        forwardRef
      } = _a,
      props = __rest(_a, ["value", "label", "hasError", "help", "disabled", "rows", "onChange", "id", "fullHeight", "forwardRef"]);
    return /*#__PURE__*/_react.default.createElement(_style2.Container, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      htmlFor: id,
      type: "label"
    }, label), /*#__PURE__*/_react.default.createElement(_style2.StyledTextArea, Object.assign({
      id: id
    }, props, {
      hasError: hasError,
      disabled: disabled,
      rows: rows > 20 ? 20 : rows,
      value: value,
      onChange: onChange,
      fullHeight: fullHeight,
      ref: forwardRef
    })), hasError && ( /*#__PURE__*/_react.default.createElement(_style.HelpTextWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.Warning, {
      size: "medium"
    }), /*#__PURE__*/_react.default.createElement(_style.HelpText, {
      type: "help",
      htmlFor: id,
      hasError: hasError
    }, help))));
  }
}
exports.default = TextArea;
TextArea.propTypes = {
  label: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  rows: _propTypes.default.number,
  id: _propTypes.default.string.isRequired,
  fullHeight: _propTypes.default.bool,
  forwardRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })])
};
TextArea.defaultProps = {
  placeholder: undefined,
  hasError: false,
  disabled: false,
  rows: 4,
  fullHeight: false,
  forwardRef: undefined
};